export const ProductGroup = (json: IProductGroup): IProductGroupModel => {
	const fromJSON = (json: IProductGroup) => {
		const { segments, ...rest } = json
		return {
			...rest,
			segments: segments ? segments.map((segment) => ProductSegment(segment)) : [],
		}
	}

	return { ...fromJSON(json) }
}

export const productGroupToJSON = (obj: Partial<IProductGroupModel>): Partial<IProductGroup> => {
	const { segments, ...rest } = obj
	return {
		...rest,
		segments: segments ? (segments.map((segment) => productSegmentToJSON(segment)) as IProductSegment[]) : [],
	}
}
